import {
	type LinkSuggestedRampVendorsMutation,
	type LinkVendorToRampVendorMutation,
	type UnlinkVendorFromRampVendorMutation
} from "~/gql/mutations/rampVendors.generated";
import { CreateVendorMutation } from "~/gql/mutations/vendor.generated";
import {
	type RampVendorLinkRowsQuery,
	type RampVendorsQuery,
	type VendorRampLinkQuery
} from "~/gql/queries/rampVendors.generated";
import { GetVendorsQuery } from "~/gql/queries/vendor.generated";

export const vendorEndpoints = {
	CreateVendor: {
		transformResponse: (res: CreateVendorMutation) => res
	},
	GetVendors: {
		providesTags: ["Vendors"] as AddTagTypes,
		transformResponse: (res: GetVendorsQuery) => res
	},
	LinkSuggestedRampVendors: {
		invalidatesTags: ["RampVendorLinks"] as AddTagTypes,
		transformResponse: (res: LinkSuggestedRampVendorsMutation) => res
	},
	LinkVendorToRampVendor: {
		invalidatesTags: ["RampVendorLinks"] as AddTagTypes,
		transformResponse: (res: LinkVendorToRampVendorMutation) => res
	},
	RampVendorLinkRows: {
		providesTags: ["RampVendorLinks"] as AddTagTypes,
		transformResponse: (res: RampVendorLinkRowsQuery) => res
	},
	RampVendors: {
		providesTags: ["RampVendorLinks"] as AddTagTypes,
		transformResponse: (res: RampVendorsQuery) => res
	},
	UnlinkVendorFromRampVendor: {
		invalidatesTags: ["RampVendorLinks"] as AddTagTypes,
		transformResponse: (res: UnlinkVendorFromRampVendorMutation) => res
	},
	VendorRampLink: {
		providesTags: ["RampVendorLinks"] as AddTagTypes,
		transformResponse: (res: VendorRampLinkQuery) => res
	}
};
